import { render, staticRenderFns } from "./WrongPage.vue?vue&type=template&id=f725d856"
import script from "./WrongPage.vue?vue&type=script&lang=js"
export * from "./WrongPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports